<mat-expansion-panel [disabled]="flujos.cuentaBancaria.bloqueado"  hideToggle [expanded]="
    flujos.datosAdjuntos.ok &&
    !flujos.cuentaBancaria.ok &&
    !flujos.cuentaBancaria.cargando">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Cuenta bancaria donde recibirás los abonos
    </mat-panel-title>
    <mat-panel-description>
      <ng-container *ngIf="showPasos === 0">
        <div></div>
      </ng-container>
      <ng-container *ngIf="showPasos === 3">
        <div>Completa sólo 3 datos</div>
      </ng-container>
      <ng-container *ngIf="showPasos === 1">
        <div>Completa sólo 1 dato</div>
      </ng-container>
      <ng-container *ngIf="showPasos === 6">
        <div>Completa sólo 6 datos</div>
      </ng-container>
      <ng-container *ngIf="showPasos === 4">
        <div>Completa sólo 4 datos</div>
      </ng-container>
      <!-- <div
        *ngIf="
          (flujos.datosAdjuntos.ok &&
          !flujos.cuentaBancaria.ok &&
          !flujos.cuentaBancaria.cargando) && showCantidadCampos
        "
      > -->
      <!--======informacion menu ======-->
      <!-- Completa sólo 2 datos
      </div> -->
      <div *ngIf="flujos.cuentaBancaria.cargando">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="flujos.cuentaBancaria.ok && !flujos.cuentaBancaria.cargando">
        <!--======ok menu ======-->
        <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <ng-container >
    <form [formGroup]="currentForm" >
      <app-messages class="informativo mt-16 p-16" [message]="message">
      </app-messages>
      <div class="row">
        <div class="col-md-6 mt-36">
          <label for="rutEmpresa">RUT del titular de la cuenta</label>
          <input type="text" name="rutEmpresa" appFormatRut formControlName="rutEmpresa" placeholder="Ej: 123456789" autocomplete="off" (blur)="determineCuentaEnvio()" [class.inputInvalido]="
              currentForm.get('rutEmpresa').invalid && currentForm.get('rutEmpresa').touched
            " required  />
          <p *ngIf="
              (currentForm.get('rutEmpresa').touched && currentForm.get('rutEmpresa') === null) ||
              (currentForm.get('rutEmpresa').touched && currentForm.get('rutEmpresa').invalid)
            " class="mensajeError">
            {{ mensajeErrorCuentaBancaria.REQUIRED_RUTEMPRESA_MESSAGE }}
          </p>
        </div>

        <ng-container *ngIf="continueForm">
          <div class="col-md-6 mt-36">
            <label *ngIf="rutEmpresa" for="razonSocial">Nombre </label>
            <label *ngIf="!rutEmpresa" for="razonSocial">Razón Social </label>
            <input  type="text" 
            name="razonSocial" 
            formControlName="razonSocial" 
            placeholder="Ingresa Nombre" 
            autocomplete="off" 
            [readonly]="processing"
            [class.inputInvalido]="currentForm.get('razonSocial').invalid && currentForm.get('razonSocial').touched" required  
            [appMaxLength]="50"
            [appCaractereslimit]="'mensajeErrorRSocial'" />
            <p *ngIf="
                (currentForm.get('razonSocial').touched &&
                  currentForm.get('razonSocial') === null) ||
                (currentForm.get('razonSocial').touched &&
                  currentForm.get('razonSocial').invalid)
              " class="mensajeError">
              {{ mensajeErrorCuentaBancaria.REQUIRED_RAZONSOCIAL_MESSAGE }}
            </p>
            <p
            id="mensajeErrorRSocial"
            class="mensajeError"
            style="display: none;"
          >
            Has alcanzado el límite máximo de caracteres (50).
          </p>
          </div>
        </ng-container>
      </div>
    <div class="row" *ngIf="continueForm && rutEmpresa">
      <div class="col-md-6 mt-36">
        <label for="primerApellido">Primer Apellido </label>
        <input
          appCaracteres
          [appMaxLength]="15"
          [appCaractereslimit]="'mensajeErrorPa'"
          type="text"
          name="primerApellido"
          formControlName="primerApellido"
          placeholder="Ingresa primer apellido"
          autocomplete="off"
          [readonly]="processing"
          [class.inputInvalido]="
            currentForm.get('primerApellido').invalid &&
            currentForm.get('primerApellido').touched
          "
        />
        <p
          *ngIf="
            currentForm.get('primerApellido').touched &&
            currentForm.get('primerApellido').invalid
          "
          class="mensajeError"
        >
          {{ mensajeErrorCuentaBancaria.REQUIRED_LASTNAME_MESSAGE }}
        </p>
        <p
        id="mensajeErrorPa"
        class="mensajeError"
        style="display: none;"
      >
        Has alcanzado el límite máximo de caracteres (15).
      </p>
      </div>
  
      <div class="col-md-6 mt-36">
        <label for="segundoApellido">Segundo Apellido (Opcional)</label>
        <input
          appCaracteres
          [appMaxLength]="15"
          [appCaractereslimit]="'mensajeErroSa'"
          type="text"
          name="segundoApellido"
          formControlName="segundoApellido"
          placeholder="Ingresa segundo apellido"
          autocomplete="off"
          [readonly]="processing"
        />
        <p
        id="mensajeErrorSa"
        class="mensajeError"
        style="display: none;"
      >
        Has alcanzado el límite máximo de caracteres (15).
      </p>
      </div>
    </div>
      <ng-container *ngIf="continueForm">
        <div class="row">
          <div class="col-md-6 mt-36">
            <label for="bancos">Banco</label>
            <select name="bancos" formControlName="bancos" (change)="recargarBancos(currentForm.get('bancos').value)" [class.selectInvalido]="
                currentForm.get('bancos').invalid && currentForm.get('bancos').touched
              ">
              <option value="">Seleccionar</option>
              <option *ngFor="let banco of bancos" [value]="banco.id">
                {{ banco.asString }}
              </option>
            </select>
            <p *ngIf="
                (currentForm.get('bancos').touched && currentForm.get('bancos') === null) ||
                (currentForm.get('bancos').touched && currentForm.get('bancos').invalid)
              " class="mensajeError">
              {{ mensajeErrorCuentaBancaria.REQUIRED_BANK_MESSAGE }}
            </p>
          </div>
          <div class="col-md-6 mt-36">
            <label for="tipoCuenta">Tipo de cuenta</label>
            <select name="tipoCuenta" formControlName="tipoCuenta" (change)="isCuentaRut($event)" [class.selectInvalido]="
                currentForm.get('tipoCuenta').invalid && currentForm.get('tipoCuenta').touched
              ">
              <option value="">Seleccionar</option>
              <option *ngFor="let tipo of tiposCuenta" [value]="tipo.id">
                {{ tipo.descripcion }}
              </option>
            </select>
            <p *ngIf="
                (currentForm.get('tipoCuenta').touched &&
                  currentForm.get('tipoCuenta') === null) ||
                (currentForm.get('tipoCuenta').touched && currentForm.get('tipoCuenta').invalid)
              " class="mensajeError">
              {{ mensajeErrorCuentaBancaria.REQUIRED_COUNTTIPE_MESSAGE }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-36">
            <label for="numeroCuenta">Número de cuenta</label>
            <input appNumeros type="text" name="numeroCuenta" formControlName="numeroCuenta" placeholder="Ej: 1096717796" autocomplete="off" appMaxLength="18" [class.inputInvalido]="
                currentForm.get('numeroCuenta').invalid && currentForm.get('numeroCuenta').touched
              " [readonly]="disableNumeroCuenta" required />
            <p *ngIf="
                (currentForm.get('numeroCuenta').touched &&
                  currentForm.get('numeroCuenta') === null) ||
                (currentForm.get('numeroCuenta').touched &&
                  currentForm.get('numeroCuenta').invalid)
              " class="mensajeError">
              {{ mensajeErrorCuentaBancaria.REQUIRED_COUNTNUMBER_MESSAGE }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-36 d-flex">
            <mat-checkbox tabindex="4" formControlName="autorizar">He verificado que el número de cuenta es correcto
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
  
      <div class="row box-button" *ngIf="!continueForm">
        <div class="col-md-12">
          <button class="btn-primary-tbk" type="submit" aria-label="continuar" (click)="continue()">
            Continuar
          </button>
        </div>
      </div>
  
      <div class="row box-button" *ngIf="continueForm">
        <div class="col-md-12">
          <button class="btn-primary-tbk" type="submit" value="ContinuarGuardar" (click)="ContinuarGuardar($event)" [disabled]="!currentForm.valid || processingCall">
            <div *ngIf="loading" class="spinner-border text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div *ngIf="!loading">Guardar</div>
          </button>
        </div>
      </div>
    </form>
  
  </ng-container>
</mat-expansion-panel>


  <!-- Modal de información para pegar datos bancarios -->
  <div class="modal fade" id="clipboardModal" tabindex="-1" role="dialog" aria-labelledby="clipboardModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.66671 15.3332C5.66671 14.5968 6.26366 13.9998 7.00004 13.9998H11C11.7364 13.9998 12.3334 14.5968 12.3334 15.3332C12.3334 16.0696 11.7364 16.6665 11 16.6665H7.00004C6.26366 16.6665 5.66671 16.0696 5.66671 15.3332Z" fill="#3B3CF7"/>
            <path d="M7.00004 19.3332C6.26366 19.3332 5.66671 19.9301 5.66671 20.6665C5.66671 21.4029 6.26366 21.9998 7.00004 21.9998H15C15.7364 21.9998 16.3334 21.4029 16.3334 20.6665C16.3334 19.9301 15.7364 19.3332 15 19.3332H7.00004Z" fill="#3B3CF7"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0667 1.10674L21.32 9.10674C21.5423 9.35127 21.6658 9.66963 21.6667 10.0001V24.0001C21.6615 24.4431 21.5691 24.8807 21.3947 25.288C21.2203 25.6953 20.9674 26.0642 20.6505 26.3737C20.3335 26.6833 19.9587 26.9273 19.5474 27.092C19.1361 27.2567 18.6964 27.3387 18.2534 27.3334H3.74671C3.30371 27.3387 2.864 27.2567 2.45271 27.092C2.04141 26.9273 1.66658 26.6833 1.34962 26.3737C1.03265 26.0642 0.779766 25.6953 0.605398 25.288C0.43103 24.8807 0.338596 24.4431 0.333374 24.0001V4.00008C0.338596 3.55708 0.43103 3.11944 0.605398 2.71217C0.779766 2.30489 1.03265 1.93595 1.34962 1.62642C1.66658 1.31688 2.04141 1.07281 2.45271 0.908152C2.864 0.743491 3.30371 0.66146 3.74671 0.666744H13.08C13.2661 0.667184 13.45 0.706559 13.6199 0.782338C13.7899 0.858116 13.942 0.96862 14.0667 1.10674ZM17.32 8.66674L13.6667 4.66674V7.53341C13.6558 7.67287 13.6728 7.8131 13.7167 7.94591C13.7606 8.07872 13.8306 8.20146 13.9224 8.30696C14.0142 8.41246 14.1262 8.49861 14.2517 8.56039C14.3772 8.62216 14.5137 8.65831 14.6534 8.66674H17.32ZM3.74671 24.6667H18.2534C18.3462 24.6721 18.4392 24.6592 18.527 24.6286C18.6148 24.598 18.6957 24.5503 18.7651 24.4884C18.8345 24.4265 18.8909 24.3515 18.9312 24.2677C18.9715 24.1839 18.9949 24.0929 19 24.0001V11.3334H14.6134C13.6314 11.3055 12.7003 10.8902 12.0233 10.1783C11.3464 9.46638 10.9785 8.51557 11 7.53341V3.33341H3.74671C3.65387 3.32801 3.56088 3.34098 3.47307 3.37158C3.38526 3.40219 3.30436 3.44982 3.23499 3.51175C3.16562 3.57369 3.10916 3.6487 3.06885 3.7325C3.02853 3.8163 3.00515 3.90723 3.00004 4.00008V24.0001C3.00515 24.0929 3.02853 24.1839 3.06885 24.2677C3.10916 24.3515 3.16562 24.4265 3.23499 24.4884C3.30436 24.5503 3.38526 24.598 3.47307 24.6286C3.56088 24.6592 3.65387 24.6721 3.74671 24.6667Z" fill="#3B3CF7"/>
            </svg>
          <p class="modal-title" id="clipboardModalLabel">
            <br /><br />
              Copia y pega tu datos bancarios
          </p>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 class="text-left"><strong>Activa y usa los datos desde el portapapeles</strong> </h3>
          <p class="text-left">
            Para activar la función <strong> pegar datos bancarios </strong>, presiona el botón <strong>Permitir</strong> que aparece arriba en tu navegador.<br />
          </p>
          <p><img src="assets/images/modal/permitepegar.png" alt="Instrucciones para copiar y pegar" style="max-width:100%; height:auto;"/></p>
          
          <button class="btn-primary-tbk ent-max mx-auto" (click)="cerrarModal()">Entendido</button>
        </div>
      </div>
    </div>
  </div>

  
<!-- Modal Pantalla Completa -->
<div class="modal fade modal-fullscreen" id="noActividadModal" tabindex="-1" role="dialog" aria-labelledby="noActividadModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <!-- Ícono de advertencia -->
        <div><svg width="97" height="97" viewBox="0 0 97 97" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M91.1763 65.8816L60.1767 14.4716C58.9232 12.5107 57.1962 10.8969 55.1549 9.77901C53.1136 8.66114 50.8237 8.0752 48.4963 8.0752C46.1689 8.0752 43.879 8.66114 41.8377 9.77901C39.7964 10.8969 38.0694 12.5107 36.8159 14.4716L5.8163 65.8816C4.72122 67.7071 4.12602 69.7886 4.09055 71.9171C4.05508 74.0455 4.58058 76.1457 5.61421 78.0066C6.80925 80.1013 8.539 81.8411 10.6267 83.0483C12.7144 84.2554 15.0852 84.8867 17.4967 84.8775H79.4959C81.8916 84.903 84.2517 84.2962 86.3379 83.1183C88.4242 81.9403 90.1628 80.2329 91.3784 78.1683C92.4424 76.288 92.9847 74.1576 92.9491 71.9975C92.9136 69.8373 92.3016 67.7259 91.1763 65.8816ZM48.4963 68.7108C47.6969 68.7108 46.9155 68.4738 46.2509 68.0297C45.5862 67.5856 45.0682 66.9543 44.7623 66.2158C44.4564 65.4773 44.3763 64.6647 44.5323 63.8806C44.6882 63.0966 45.0732 62.3765 45.6384 61.8112C46.2036 61.246 46.9238 60.8611 47.7078 60.7051C48.4918 60.5492 49.3045 60.6292 50.043 60.9351C50.7815 61.241 51.4127 61.7591 51.8568 62.4237C52.3009 63.0884 52.538 63.8698 52.538 64.6691C52.538 65.7411 52.1121 66.7691 51.3542 67.527C50.5962 68.285 49.5682 68.7108 48.4963 68.7108ZM52.538 52.5441C52.538 53.6161 52.1121 54.6441 51.3542 55.402C50.5962 56.16 49.5682 56.5858 48.4963 56.5858C47.4244 56.5858 46.3964 56.16 45.6384 55.402C44.8805 54.6441 44.4546 53.6161 44.4546 52.5441V36.3775C44.4546 35.3056 44.8805 34.2775 45.6384 33.5196C46.3964 32.7616 47.4244 32.3358 48.4963 32.3358C49.5682 32.3358 50.5962 32.7616 51.3542 33.5196C52.1121 34.2775 52.538 35.3056 52.538 36.3775V52.5441Z" fill="#DB9A40"/>
          </svg></div>
        
        <!-- Título principal -->
        <h2 class="mb-3 title-modal">
          El RUT ingresado no ha iniciado actividades en el Servicio de impuestos internos (SII)
        </h2>
        
        <!-- Texto explicativo -->
        <p class="mb-4">
          Desde el primero de abril 2025, ningún proveedor de medios de pago podrá dar este servicio
          a los comercios o personas sin inicio de actividades.
        </p>
        
        <!-- Pregunta -->
        <p class="mb-4">¿Quieres que te orientemos con esto?</p>
        
        <!-- Botones -->
        <div class="d-flex justify-content-center mb-3">
          <button class="btn-primary-tbk mr-4 ">Sí, quiero que me llamen</button>
        </div>
        <div class="d-flex justify-content-center mb-4">
          <button  class="btn-secondary-tbk mr-4" >En qué consiste iniciar actividades</button>
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-link btn-link-tbk" (click)="goToLogin()">No por ahora</button>
        </div>
      </div>
    </div>
  </div>
</div>